'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { liveChatStore } from '@/stores/liveChatStore';

import { ChatEventsListener } from './ChatEventsListener';
import { ChatStoreHandler } from './ChatStoreHandler';

/**
 * Handle the integration with the LiveChat widget
 */
export const ChatIntegration: FC = () => {
  const { isInitialized } = liveChatStore(
    ({ isInitialized }) => ({
      isInitialized,
    }),
    shallow,
  );
  if (!isInitialized) {
    return null;
  }
  return (
    <>
      <ChatEventsListener />
      <ChatStoreHandler />
    </>
  );
};
